import { Component, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { RootService } from 'src/app/shared/services/root.service';
import { Options } from '@angular-slider/ngx-slider';
import { BreadcrumbComponent } from 'src/app/shared/components/breadcrumb/breadcrumb.component';
import { isPlatformBrowser } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-extended-vas',
  templateUrl: './extended-vas.component.html',
  styleUrls: ['./extended-vas.component.scss']
})
export class ExtendedVasComponent implements OnInit {
  productId: any;
  breadcrumbData: any[];
  lobSeo: any;
  subLob: any;
  pplSeo: any;
  model: any;
  userData: any;
  isUserLoggedIn: boolean;
  vc_no: string;
  carddata: any;
  isAMC: boolean;
  extendedArrayData: any = [];
  selectedPrice: string;
  VasData: any;
  isHCV: boolean = false;
  showBreadCrumb = false
  breadcrumbList: {
    label: any; url: string;
    pageName: string;

  };
  breadcrumblen: any = 0;

  amcDurationOptions: Options = {
    floor: 12,  // Minimum value
    ceil: 72,   // Maximum value (assuming based on your array of ['12', '24', '36', '48', '60', '72'])
    step: 12,
    showTicks: true,
  };
  annualRunningHoursOptions: Options = {
    floor: 1,
    ceil: 5,
    step: 1,
    showTicks: true,
  };

  annualRunningHours: any;
  amcDuration: any;
  plData: string;
  annual_kms: any;
  amc_duration: any;
  kms: any  = [];
  year: any = [];
  sliderReq: any;
  breadcrumbdata: any[];
  selectedExtendedWarranty: { [key: string]: boolean } = {};
  amcBookingListUrl: any = [];
  selectVas: any=[];
  vasDataArr: any;
  amcData:any = []

  constructor(
      @Inject(PLATFORM_ID) private platformId: Object,
      private activatedRoute: ActivatedRoute,
      private behaviorService: BehaviourSubjectService,
      private rootService: RootService,
      private apiService: ApiService,
      private router: Router,
      private localstore: secureStorage,
      private behaviourSubject: BehaviourSubjectService,
      private localStorage: secureStorage,private spinner: NgxSpinnerService
    ) { }

  extendedWarranty:any;
  onsiteService:any;
  fleetEdgePlan:any;
  annualHours:any;
  tenureYears:any;
  sub: Subscription = new Subscription();

    ngOnInit(): void {
      this.sub.add(
        this.behaviorService.isLoggedIn.subscribe(() => {
          this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
          this.userData = this.rootService.getUserData();
        })
      );
      if (isPlatformBrowser(this.platformId)) {
      this.amcBookingListUrl = JSON.parse(this.localStorage.getItem('amcBookingListUrl'));
      this.amcBookingListUrl = this.amcBookingListUrl?.split('booking-amc-list')
      this.extendedArrayData = JSON.parse(localStorage.getItem('extendedVas'))
      if(this.localStorage.getItem('VASData')){
        this.vasDataArr = JSON.parse(this.localStorage.getItem('VASData'))
      }    
    }
      const index = this.extendedArrayData?.amcDataArray?.findIndex(obj => obj?.plan?.toLowerCase().split(' ').includes('amc'));
      if (index !== -1) {
        this.extendedArrayData?.amcDataArray?.splice(index, 1);
      }
      this.extendedArrayData = this.extendedArrayData?.amcDataArray;
      this.VasData = this.localstore.getItem('VASData') ? JSON.parse(this.localstore.getItem('VASData')) : null;
      setTimeout(() => {
        this.annualRunningHours = this.VasData?.AnnualKms;
        this.amcDuration = this.VasData?.NoOfyears
      }, 2000);
      this.selectedPrice = this.VasData?.VASTotalAmount
      this.activatedRoute.paramMap.subscribe((params) => {
        this.tenureYears = this.tenureYears ? this.tenureYears /12 : 1;
        if (params.get('id')) {
          this.productId = params.get('id');
          this.breadcrumbData = [
            params.get('lob_seo'),
            params.get('sub_lob'),
            params.get('ppl_seo'),
            params.get('model'),
          ];
          this.lobSeo = params.get('lob_seo');
          this.subLob = params.get('sub_lob');
          this.pplSeo = params.get('ppl_seo');
          this.model = params.get('model');
        }
      });

      if(this.extendedArrayData?.length == 0){
        this.submitData();
      }
      this.upDateCheckBox();
      this.isHCV = this.extendedArrayData?.isHcv
      this.breadcrumb()
    }




   async submitData(){
  
       let amcSelectedPlan = JSON.parse(this.localStorage.getItem('amcListSelected'))
       amcSelectedPlan['plan'] = amcSelectedPlan?.VASPLAN 
       amcSelectedPlan['contract years'] = amcSelectedPlan?.NoOfyears
     
      if (Array.isArray(this.VasData.VASPLAN)) {
        const isDuplicate = this.VasData.VASPLAN.some(ele => ele.plan === amcSelectedPlan.plan);
        
        if (!isDuplicate) {
          this.VasData.VASPLAN.unshift(amcSelectedPlan);
        }
      }
      this.localstore.setItem('VASData', JSON.stringify(this.VasData));
      let id = localStorage.getItem('tat_id');
      if (id !== null && id !== undefined) {
        try {
          await this.vastatrequestresponsereturn(); // Wait for API response
        } catch (error) {
          console.error("Error in vastatrequestresponse:", error);
        }
      }
      if (this.isUserLoggedIn) {
        let sub_lob =this.subLob.replace(/\s/g, '-')?.toLowerCase() == 'icv-trucks' ? 'trucks' : this.subLob.replace(/\s/g, '-')?.toLowerCase() == 'buses' ? 'buses-vans' : this.subLob.replace(/\s/g, '-')?.toLowerCase();
        let model = this.model
          .replace(/\s/g, '-')
          .replace(/\//g, '-')
          .replace(/\+/g, '-')
          .replace(/\./g, '-')
          ?.toLowerCase();
        this.router.navigate([
          '/lead-booking/' +
            sub_lob +
            '/' +
            this.lobSeo +
            '/' +
            this.pplSeo +
            '/' +
            model +
            '/' +
            this.productId,
        ]);
      }
    }

    upDateCheckBox() {
      if (Array.isArray(this.vasDataArr?.extendedWarranty) && this.vasDataArr.extendedWarranty.length > 0) {
          this.selectedExtendedWarranty = {};
          this.vasDataArr.extendedWarranty.forEach(plan => {
              if (this.extendedArrayData.some(item => item.plan === plan)) {
                  this.selectedExtendedWarranty[plan] = true;
              } else {
                  this.selectedExtendedWarranty[plan] = false;
              }
          });
      } else {
          this.selectedExtendedWarranty = {};
      }
  }
  getExtendedVas(event, data) {
    if (event.target.checked) {
      if (!this.selectVas.some(item => item.plan === data.plan)) {
        this.selectVas.push(data);
      }
    } else {
      this.selectVas = this.selectVas.filter(item => item.plan !== data.plan);
      this.extendedArrayData?.filter((ele)=>{
        if(this.VasData['extendedWarranty'].includes(ele?.plan)){
          this.amcData.pop(data?.plan)
        }
      })
    }
    
    let totalVasAmount = Number(this.VasData?.VASTotalAmount || 0); // Ensure it's a number
  
    // Ensure extendedWarranty is an array
    if (!Array.isArray(this.VasData['extendedWarranty'])) {
      this.VasData['extendedWarranty'] = [];
    }
  
    if (event.target.checked) {
      // Add to extendedWarranty if not already present
      if (!this.VasData['extendedWarranty'].includes(data?.plan)) {
        this.VasData['extendedWarranty'].push(data?.plan);
      }
      this.VasData['VASTotalAmount'] = totalVasAmount + data?.price_per_year;
      this.selectedExtendedWarranty[data?.plan] = true;
    } else {
      // Remove from extendedWarranty
      this.VasData['extendedWarranty'] = this.VasData['extendedWarranty'].filter(plan => plan !== data?.plan);
      this.VasData['VASTotalAmount'] = totalVasAmount - data?.price_per_year;
      this.selectedExtendedWarranty[data?.plan] = false;
    }  
  
    this.extendedArrayData?.filter((ele)=>{
      if(this.VasData['extendedWarranty'].includes(ele.plan)){
        this.amcData.push(ele)
      }
    })
    this.VasData['VASPLAN'] = this.amcData ? [...new Set(this.amcData)] : [];
    this.selectedPrice = this.VasData?.VASTotalAmount;
    console.log('000000000000000',this.VasData)
  }

   breadcrumb() {
      if (isPlatformBrowser(this.platformId)) {
        localStorage.removeItem('localBreadCrumb');
      }
        this.breadcrumbdata = []
        this.breadcrumbList = {
          label: 'Product List',
          url: `/product-list/`,
          pageName: 'product-list',

        };
        this.breadcrumbdata.push(this.breadcrumbList);
        this.breadcrumbList = {
          label: 'AMC Booking List',
          url: `/booking-amc-list` +  decodeURIComponent(this.amcBookingListUrl?.[1]),
          pageName: 'amc-booking-list',

        };
        this.breadcrumbdata.push(this.breadcrumbList);
        this.breadcrumbList = {
          label: 'Extended Vas Warranty',
          url: ``,
          pageName: 'extended-vas',

        };
        this.breadcrumbdata.push(this.breadcrumbList);
        if (isPlatformBrowser(this.platformId)) {
          this.localStorage.setItem(
            'localBreadCrumb',
            JSON.stringify(this.breadcrumbdata)
          );
        }
        this.showBreadCrumb = true;
      
    }

  generateStepsArray(): void {
    this.annualRunningHoursOptions.readOnly = true;
    this.amcDurationOptions.stepsArray = this.year.map((value) => {
      return { value };
    });
  }

  generateStepsArraykms(): void {
    this.amcDurationOptions.readOnly = true;
    this.annualRunningHoursOptions.stepsArray = this.kms.map((value) => {
      return { value };
    });
  }

  backToAmcBookingList(){
    this.router.navigate([
      `/booking-amc-list` +  decodeURIComponent(this.amcBookingListUrl?.[1])
    ]);
  }
  vastatrequestresponsereturn(data?): Promise<any> {
    return new Promise((resolve, reject) => {
      if (isPlatformBrowser(this.platformId)) {
      let vas_data =  this.localstore.getItem('VASData') ? JSON.parse(this.localstore.getItem('VASData')) : null;


     let id = localStorage.getItem('tat_id');
      let Payload = {
        "id": id ? id:'',
        "home_configurator_request": '',
        "home_configurator_response":'',
        "osp_configurator_vas_filter_request":'',
        "osp_configurator_vas_filter_response":'',
        "request_id": "",
        "vehicle_number":'',
        "model":'',
        "number_of_vehicles":'',
        "application": vas_data?.vasApplication ? vas_data?.vasApplication : '',
        "terrain":vas_data?.terrian ? vas_data?.terrian : '',
        "annual_runnig":'',
        "duration_of_amc":'',
        "vas_offer":'',
        "amc": "",
        "fms": "",
        "ew": this.getPlanPrice('Extended Warranty'),
        "oss": "",
        "fleetedge": this.getPlanPrice('ADVANCE FLEETEDGE'),
        "uptime_guarantee": this.getPlanPrice('Uptime Guarantee'),
        "source": "",
        "vas_booking_price":"",
      };
  
      this.spinner.show();
  
      this.apiService.getvastat(Payload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res?.success) {
            resolve(res);
          } else {
            reject("API call failed.");
          }
        },
        error: (error: any) => {
          this.spinner.hide();
          reject(error);
        },
        complete: () => {
          this.spinner.hide();
        }
      });
    }
    });
  }
  getPlanPrice(planName: string): string {
    let vasData = this.localstore.getItem('VASData');
    let parsedData = vasData ? JSON.parse(vasData) : {}; 

    if (!Array.isArray(parsedData?.VASPLAN) || parsedData.VASPLAN.length === 0) {
        return "";
    }

    let filteredPlans = parsedData.VASPLAN.slice(1);

    const plan = filteredPlans.find(item => item.plan?.toUpperCase() === planName.toUpperCase());

    if (plan && Number.isFinite(plan.price_per_year)) {
        return `${Math.round(plan.price_per_year)}`;
    } else {
        return "0";
    }
}


    
}
